import { injectReducer } from '../../store/reducers'
import { getList } from './modules/status'
export default (store) => ({
  path : 'status',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Status = require('./containers/StatusContainer').default
      const reducer = require('./modules/status').default
      injectReducer(store, { key: 'status', reducer })
      store.dispatch(getList());
      cb(null, Status)
    }, 'status')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Status/index.js